<template>
  <div class="paper-example">
    <h1>2019届高三高考真题训练——人民版必修二  专题三  中国建设社会主义道路的探索</h1>
    <div class="paper-body">
      <question-box v-for="(question,index) in questions" :question="question" :key="index"></question-box>
    </div>
  </div>
</template>
<script type="text/babel">

  import questionBox from '../../../../../components/question/question-box.vue';

  export default {
    components: {
      questionBox
    },
    data: function() {
      return {
        questions:[
          {
            "id": 11937354,
            "stem": "<p style=''>1973年3月15日，中央电视台首次播出外商广告“西铁城——星辰表”。这反映出</p>",
            "options": {
              "A": "中国人走向世界的愿望",
              "B": "国外普遍赞赏中国开放政策",
              "C": "人民生活水平显著提高",
              "D": "中国全面推行改革开放政策"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：材料显示的是中国首次播出外商广告，所以不能显示出人民生活水平显著提高，故排除C；根据材料所提到的时间1973年，可以知道这是中国还没有做出实行改革开放的决策，所以BD错误；材料可以显示中国人希望了解世界，故选择A。</span><p style=''>考点：中国特色社会主义建设的道路••20世纪50年代至70年代探索社会主义建设道路的实践•中国与世界的关系。</p></span>"
          },
          {
            "id": 11957266,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图是某一时期的宣传画，它宣传的是</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272190977/STEM/de83be5a0b9747de9f2be2f75dd014f4.png\" width=\"119\" height=\"168\" /></p>",
            "options": {
              "A": "土地改革",
              "B": "“文化大革命”",
              "C": "粉碎“四人帮”",
              "D": "“多快好省地建设杜会主义”"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：宣传语的关键词是三面红旗——“总路线、大跃进、人民公社”，1958年5月，在北京召开的党的八大二次会议根据毛泽东的创意，通过了“鼓足干劲、力争上游、多快好省地建设社会主义”的总路线，进而掀起大跃进、人民公社化运动D正确，排除ABC。</span><p style=''>考点：社会主义建设道路的探索与曲折·社会主义建设道路的初步探索·“三面红旗”。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1981年中共中央27号文件指出，经济特区的“特”字主要在于实行国家规定的特殊经济政策和特殊经济管理体制，它主要包括</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >①较大的经济管理权限</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >②独立的管理体制</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >③社会主义经济领导下的多种经济成分并</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >④市场调节为主。</span></p>",
            "options": {
              "A": "①②③",
              "B": "①②④",
              "C": "①③④",
              "D": "②③④"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题实际上考查的是对概念的理解和运用能力。经济特区实行特殊的经济政策和经济管理体制，建设上以吸收利用外资为主，经济所有制实行以社会主义公有制为主导的多元化结构；经济活动在国家宏观经济指导调控下，以市场调节为主；对外商投资给予优惠和方便；特区拥有较大的经济管理权限。所以答案选C；②独立的管理体制说法错误，排除ABD三项。</span><p style=''>考点：中国特色社会主义建设的道路·对外开放格局的初步形成·经济特区</p><p style=''>【名师点睛】1979年4月邓小平首次提出要开办“出口特区”，后于1980年3月，“出口特区”改名为“经济特区”，并在深圳加以实施。按其实质，经济特区也是世界自由港区的主要形式之一。以减免关税等优惠措施为手段，通过创造良好的投资环境，鼓励外商投资，引进先进技术和科学管理方法，以达促进特区所在国经济技术发展的目的。经济特区实行特殊的经济政策，灵活的经济措施和特殊的经济管理体制，并坚持以外向型经济为发展目标。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图为商务印书馆1978年12月出版的《现代汉语词典》中的一个词条。它反映出当时</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272076289/STEM/67a8461d985246b3b024990f3de8d851.png\" width=\"245\" height=\"125\" /></p>",
            "options": {
              "A": "对“大跃进”运动有了客观认识",
              "B": "“拨乱反正”工作取得了重大进展",
              "C": "“左”倾思想影响依然比较严重",
              "D": "确立了实事求是的思想路线"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题解析：</span><p style=''>本题主要考查对图片中的信息正确解读的能力。由题目中的信息“大跃进......（使）我国在工业、农业等各方面出现的飞跃发展”即可排除A、B、D三项，选择C项。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >改革开放后，中共中央明确将中共八大作为探索中国社会主义建设道路的开端．这是因为中共八大</span></p>",
            "options": {
              "A": "<span style=\"\" >客观分析了当时的国内形势与主要矛盾的变化</span>",
              "B": "<span style=\"\" >实现了工作重心向社会主义现代化建设的转变</span>",
              "C": "<span style=\"\" >明确提出社会主义初级阶段的理论</span>",
              "D": "<span style=\"\" >全面总结了新民主主义革命的经验</span>"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：中共八大是社会主义制度在中国确立以后，开始探索中国经济建设的会议，八大正确分析了当时中国主要矛盾是人民对于建立先进工业国与落后农业国的现实之间的矛盾，故答案为A；B是十一届三中全会，C是中共十三大，D不是八大内容，排除BCD。</span><p style=''>考点：中国特色社会主义建设的道路·经济建设的发展和曲折·探索与失误</p></span>"
          },
          {
            "id": 11990356,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图为新中国第一个五年计划期间中国、美国、英国主要工业指标年均增长速度的比较．据此可以推知</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272018944/STEM/ac8f38c3d14e4983aa777d3c3aeb494b.png\" width=\"335\" height=\"195\" /></p>",
            "options": {
              "A": "<span style=\"\" >中国原有工业基础很薄弱</span>",
              "B": "<span style=\"\" >冷战制约美英工业发展</span>",
              "C": "<span style=\"\" >中国重工业发展急躁冒进</span>",
              "D": "<span style=\"\" >美英传统工业产业衰落</span>"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：图表反映出在一五计划期间中国的工业指标增长率要远远高于美国和英国，结合所学知识可知当时中国的工业基础很薄弱，所以发展速度较快。所以本题答案为A项</span><p style=''>考点：中国社会主义建设道路的探索·社会主义建设道路的初期探索·一五计划</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1978年5月，《光明日报》刊发的《实践是检验真理的唯一标准》引起了广泛关注。该文初稿作者在听到赞誉声的同时，也因看到一些报刊批评该文“违反中央精神和反对毛泽东思想”，转而安排“后事”：“我已经有思想准备了，我准备要坐牢。”上述材料表明当时</span></p>",
            "options": {
              "A": "<span style=\"\" >社会舆论呈“百花齐放”之势</span>",
              "B": "<span style=\"\" >“左”倾束缚亟待突破</span>",
              "C": "<span style=\"\" >十一届三中全会精神渐入人心</span>",
              "D": "<span style=\"\" >“两个凡是”名存实亡</span>"
            },
            "children": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >根据题干中提到“《实践是检验真理的唯一标准》的作者，因为批判了‘左’倾错误思想而准备后事”的这一现象，可知当时“左”错误还未完全结束，故B项正确；题干中并未体现出当时的社会出现各种各样的思想舆论，故A项错误；十一届三中全会于1978年12月召开，故C项错误；题干中提到“《实践是检验真理的唯一标准》的作者因看到一些报刊批评该文‘违反中央精神和反对毛泽东思想’而安排后事”可知这一时期“两个凡是”的思想依然具有较强的影响力，故D项错误。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >点睛：抓住关键信息“我已经有思想准备了，我准备要坐牢。”联系十一届三中全会的背景分析解答。</span></p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >天津经济技术开发区（泰达）是20世纪80年代国务院批准建立的首批国家级开发区之一。在全国国家级开发区、工业园区投资环境评价中，天津开发区已连续多年位居前列。当初其设立的主要目的是</span></p>",
            "options": {
              "A": "服务于天津自由贸易区的建设",
              "B": "推动经济体制改革不断深化",
              "C": "引进外资，生产高新技术产品或出口产品",
              "D": "加强天津对内地的辐射作用"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：根据所学知识可知，20世纪80年代中国政府在沿海和其他地区的开放城市中，划出一定区域建立经济技术开发区，其目的是是引进外资，生产高新技术产品或加工出口产品。本题选C。天津自由贸易区是在2015年才设立的，排除A。设立经济技术开发区属于对外开放的内容，不是经济体制改革，排除B。D项是一个干扰项，经济技术开发区主要侧重于高新技术产品的生产，加强对内地的辐射作用只是其次要目的之一。</span><p style=''>【考点定位】中国特色社会主义建设的道路·对外开放格局的初步形成·经济技术开发区。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >下面的新闻出自那一时期？</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272158209/STEM/a500d80fa1a44bfa9b9ec0f55a13f2b7.png\" width=\"226\" height=\"188\" /></p>",
            "options": {
              "A": "“大跃进”时期",
              "B": "土地改革时期",
              "C": "“文化大革命”时期",
              "D": "改革开放时期"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >本题考查大跃进。依据所学知识可知，新闻中“卫星农业社”、“二亩九分小麦亩产3530斤”很明显是浮夸风，是大跃进的产物。所以本题正确答案为A项。土地改革时期是个体经营与图片中“农业社”的信息无关，故排除B项；“文化大革命”时期，以阶级斗争为纲，与农业生产的浮夸风无关，故C项错误；改革开放时期，重新确立了实事求是的思想路线，与浮夸风也没有关系，故D项错误。</span><p style=''>【考点定位】社会主义建设道路的探索与曲折•社会主义建设道路的初步探索•三面红旗</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >一位农民在日记中写道：“由于单家独户的经营经不起天灾人祸的袭击，有的贫农家薄，缺资金，仍不能大翻身，困难不少，出现了个别卖地卖牲口、出卖劳动力的现象。政府号召组织起来，在搭工帮工的基础上成立互助组。我是青年团员，还是乡上的人民代表，我能落后吗？”其描述反映的是</span></p>",
            "options": {
              "A": "农业合作化",
              "B": "“三年经济困难”时期",
              "C": "人民公社化",
              "D": "家庭联产承包责任制"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查学生阅读史料，提炼有效信息的能力，解答本题的关键是找准切入点，依据材料中“单家独户经营经不起天灾人祸的袭击”“搭工帮工的基础上成立互助组”等信息可得出材料主要阐述的是三大改造中对农业的改造，即农业合作化，依据已学知识可知在新中国成立前后，全国开展了土地改革运动，农民获得了土地，但农业仍然以个体生产为主，随后，人民政府领导农民组织互助组、试办初级社，三大改造后，农业生产合作社迅速发展，到1956年底，农业合作化在全国基本实现，农业社会主义改造基本完成，A符合题意，B的表述均与题意无关；C项是“一大二共”不是搭工帮工的基础上成立互助组；D项是农户以家庭为单位个体经营，不符合题意。故选A。</span><p style=''>考点：中国特色社会主义建设的道路•20世纪50年代至70年代探索社会主义建设道路的实践•三大改造</p><p style=''>【名师点睛】新中国成立后农村四次生产关系的变动：</p><p style=''>第一次：1950年土地改革，变原来的地主土地所有制为农民土地所有制，但私有制性质没变。第二次：1956年三大改造，变原来的农民私有制为社会主义全民公有制。至此公有制确立。第三次 ：1958年，人民公社化运动，农民开始吃大锅饭。第四次：1978年，改革开放。实行家庭联产承包责任制。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >宣传画是一种以宣传鼓动、制造社会舆论和气氛为目的艺术形式。如图为1955年出版的宣传画，它宣传鼓动的主要内容是</span></p><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272182784/STEM/87e05dee153b4558ba901cc894036226.png\" width=\"179\" height=\"154\" /></p>",
            "options": {
              "A": "农业合作化",
              "B": "“大跃进”运动",
              "C": "人民公社化运动",
              "D": "家庭联产承包责任制"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查学生调动知识运用知识的能力，此题考查社会主义道路探索的相关知识点。通过对图片的观察以及对题文所给提示信息：可知右图为1955年出版的宣传画，根据所学知识，它宣传鼓动的主要内容是农业合作化，选项中A符合题意，故选A。</span><p style=''>考点：中国特色社会主义建设·经济体系探索·一五计划</p></span>"
          },
          {
            "id": 11998411,
            "stem": "<p style=''>经济学家吴敬琏认为，改革不仅是一场破除旧体制的深刻革命，而且是一项建设新经济体系的宏大工程。这个体系主要是由自主经营、自负盈亏的企业，竞争性的市场体系和主要通过市场进行调节的宏观管理体系三者组成。下列与“新经济体系”内涵相近的是（    ）</p>",
            "options": {
              "A": "社会主义三大改造",
              "B": "社会主义计划经济体制",
              "C": "对外开放基本国策",
              "D": "社会主义市场经济体制"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：</span><p style=''>本题主要考查知识迁移能力。材料中“这个体系主要是由自主经营、自负盈亏的企业，竞争性的市场体系和主要通过市场进行调节的宏观管理体系三者组成”，当指社会主义市场经济体制，其目标的确定是10092年的十四大。四个选项中，A是1953年到1956年，排除；B是1956年三大改造确定的，排除；C是1978年十一届三中全会确定的，排除；只有D选项社会主义市场经济体制是最近20年才出现。故答案选D。</p><p style=''>考点：现代中国的经济建设·社会主义建设的新时期·邓小平理论</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1961年，中共中央农村工作部的一份报告指出：现在部分干部和农民对集体生产信心不足，以致发展到变相恢复单干，有的地方出现了“父子队”“兄弟队”式家庭作业。这则材料作为例证，可用于说明</span></p>",
            "options": {
              "A": "<span style=\"\" >当时土地所有制发生改变</span>",
              "B": "<span style=\"\" >农业合作化运动的历史背景</span>",
              "C": "<span style=\"\" >当时国民经济调整成效显著</span>",
              "D": "<span style=\"\" >家庭联产承包责任制的起源</span>"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >根据所学知识，</span><span style=\"font-family: Times New Romance;\" >1961</span><span style=\"font-family: 宋体;\" >年处于人民公社化运动时期，土地集体所有制性质没有改变，故排除</span><span style=\"font-family: Times New Romance;\" >A</span><span style=\"font-family: 宋体;\" >；农业合作化运动是在三大改造中，与材料中的时间不符，故排除</span><span style=\"font-family: Times New Romance;\" >B</span><span style=\"font-family: 宋体;\" >；题干材料“部分干部和农民对集体生产信心不足，以致发展到变相恢复单干”，说明当时国民经济调整并没有取得显著成效，故排除</span><span style=\"font-family: Times New Romance;\" >C</span><span style=\"font-family: 宋体;\" >；材料中“变相恢复单干”、“父子队”、“兄弟队”这同后来的家庭联产承包责任制有共通之处，是家庭联产承包责任制的起源，</span><span style=\"font-family: Times New Romance;\" >D</span><span style=\"font-family: 宋体;\" >项符合题意。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：人民公社化运动阻碍了生产力的发展</span><span style=\"font-family: Times New Romance;\" >，</span><span style=\"font-family: 宋体;\" >不利于调动农民的生产积极性。</span><span style=\"font-family: Times New Romance;\" >20</span><span style=\"font-family: 宋体;\" >世纪</span><span style=\"font-family: Times New Romance;\" >60</span><span style=\"font-family: 宋体;\" >年代初期农民单干的家庭生产方式是对人民公社化运动弊端的具体反抗</span><span style=\"font-family: Times New Romance;\" >，</span><span style=\"font-family: 宋体;\" >也是十一届三中全会后实行家庭联产承包责任制的起源。启示</span><span style=\"font-family: Times New Romance;\" >:</span><span style=\"font-family: 宋体;\" >生产关系的变革要与生产力水平相适应。</span></p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1956年，浙江温州有合作社曾实行包产到户，到1957年温州地区实行包产到农户占入社农户的15%，与此同时，四川、广东、安徽等省一些农业社也先后实行了包产到户．此后直到70年代，仍有一些地方曾实行包产到户．这一现象反映了</span></p>",
            "options": {
              "A": "<span style=\"\" >农村基层政权管理体制薄弱</span>",
              "B": "<span style=\"\" >市场经济在农户经营中起重要作用</span>",
              "C": "<span style=\"\" >基层的探索为农村经济体制改革奠定基础</span>",
              "D": "<span style=\"\" >农村经济体制改革基本上是自下而上推进</span>"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;\" >材料主要讲述的是包产到户的问题，论述的是经济问题，A项涉及的是政治管理问题，不符合材料； B选项错误，市场经济体制是在1992年之后才开始建立；D项时间不符，农村经济体制改革是20世纪70年代末；四川、安徽、广东等地出现的包产到户现象为我国推行家庭联产承包责任提供了借鉴，C项正确。</span></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1957年底到1960年，我国职工人数从3101万猛增至5969万．这主要是因为</span></p>",
            "options": {
              "A": "<span style=\"\" >第一个五年计划顺利完成</span>",
              "B": "<span style=\"\" >“大跃进”中大办工矿企业</span>",
              "C": "<span style=\"\" >公私合营后国营企业职工大增</span>",
              "D": "<span style=\"\" >人口增长造成大量劳动力剩余</span>"
            },
            "children": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >结合所学知识可知，</span><span style=\"font-family: Times New Romance;\" >1957</span><span style=\"font-family: 宋体;\" >年，第一个五年计划顺利完成。故</span><span style=\"font-family: Times New Romance;\" >A</span><span style=\"font-family: 宋体;\" >与题干的“</span><span style=\"font-family: Times New Romance;\" >1957</span><span style=\"font-family: 宋体;\" >年底到</span><span style=\"font-family: Times New Romance;\" >1960</span><span style=\"font-family: 宋体;\" >年”不符，故</span><span style=\"font-family: Times New Romance;\" >A</span><span style=\"font-family: 宋体;\" >不符合题意；大跃进</span><span style=\"font-family: Times New Romance;\" >1958</span><span style=\"font-family: 宋体;\" >年开始，</span><span style=\"font-family: Times New Romance;\" >1960</span><span style=\"font-family: 宋体;\" >年结束。“大跃进”中大办工矿企业导致职工人数猛增。故</span><span style=\"font-family: Times New Romance;\" >B</span><span style=\"font-family: 宋体;\" >符合题意；公私合营与三大改造有关，三大改造在</span><span style=\"font-family: Times New Romance;\" >1956</span><span style=\"font-family: 宋体;\" >年底结束。故</span><span style=\"font-family: Times New Romance;\" >C</span><span style=\"font-family: 宋体;\" >与题干的“</span><span style=\"font-family: Times New Romance;\" >1957</span><span style=\"font-family: 宋体;\" >年底到</span><span style=\"font-family: Times New Romance;\" >1960</span><span style=\"font-family: 宋体;\" >年”不符，故</span><span style=\"font-family: Times New Romance;\" >C</span><span style=\"font-family: 宋体;\" >不符合题意；人口增长造成大量劳动力剩余与题干的“我国职工人数从</span><span style=\"font-family: Times New Romance;\" >3101</span><span style=\"font-family: 宋体;\" >万猛增至</span><span style=\"font-family: Times New Romance;\" >5969</span><span style=\"font-family: 宋体;\" >万”无关。故</span><span style=\"font-family: Times New Romance;\" >D</span><span style=\"font-family: 宋体;\" >不符合题意。故选</span><span style=\"font-family: Times New Romance;\" >B。</span></span>"
          },
          {
            "stem": "<p style=''>20世纪80年代，农村改革的突破性进展推动了城市经济体制改革。学者敏锐地看到“公社体制改革后，农工分了手，农业经营承包到户”；企业家感慨“现在不同了，我得考虑如何增强企业活力”。这表明</p><p style=''>①人民公社体制逐步废除    </p><p style=''>②企业生产经营自主权扩大</p><p style=''>③现代企业制度开始试点 </p><p style=''>④非公有制经济开始起主导作用</p>",
            "options": {
              "A": "①②",
              "B": "②③",
              "C": "①③",
              "D": "②④"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查经济体制改革。“公社体制改革后，农工分了手，农业经营承包到户”，说明人民公社体制逐步废除，家庭联产承包责任制得以推广；企业家感慨，“时代不同了，我得考虑如何增强企业活力”，说明农村改革的突破性进展推动了城市经济体制改革，企业生产经营自主权扩大。所以①②正确；现代企业制度开始试点是在20世纪90年代，排除③；1956年三大改造完成后，社会主义公有制经济始终起主导作用，④不符合史实。所以本题选A。</span><p style=''>考点：中国特色社会主义建设道路·家庭联产承包责任制和国有企业改革·农村经济体制改革、城市经济体制改革</p><p style=''>【名师点睛】</p><p style=''><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2016/9/27/1578974472839168/1578974473052160/EXPLANATION/6da83ace8e034c86a4456f64b8548efc.png\" /></p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >与1952年相比，1957年我国生产资料的生产增长210%，消费资料的生产增长83%，重工业生产在工业总产值中的比重由35．5%提高到45%．这说明第一个五年计划期间</span></p>",
            "options": {
              "A": "<span style=\"\" >工业结构得到了改善</span>",
              "B": "<span style=\"\" >国家基本实现工业化</span>",
              "C": "<span style=\"\" >工农业生产比例协调</span>",
              "D": "<span style=\"\" >工业总产值超过农业</span>"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查学生阅读史料，提取有效信息的能力。从1953年起，国家开始执行第一个五年计划，其基本任务是：集中主要力量发展重工业，建立国家工业化的初步基础；有步骤地对农业、手工业和资本主义工商业进行社会主义改造。中国的社会主义建设由此起步。到1957年，第一个五年计划的各项指标大都大幅度超额完成。中国开始改变工业落后的面貌，旧中国时期轻重工业比例失调的工业结构得到了改善， 为国民经济的进一步发展打下了良好的基础。本题ABD三项说法与事实不符，选C项。</span><p style=''>考点：社会主义现代化建设的曲折发展·新中国成立初期的经济建设·国民经济的恢复</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1989年，邓小平会见来访的苏共领导人时，充分肯定了苏联对中国的帮助，认为“苏联帮助我们搞了一个工业基础”。这里的“工业基础”初步建立于新中国的</span></p>",
            "options": {
              "A": "国民经济恢复时期",
              "B": "“一五”计划时期",
              "C": "“大跃进”时期",
              "D": "国民经济调整时期"
            },
            "children": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查获取材料信息和运用所学知识的能力。建国初期，中苏友好，苏联援建中国156个工业项目，一五计划的完成奠定了中国工业化的基础，B项正确。国民经济恢复时期，工业基础薄弱，A项错误；“大跃进”时期和国民经济调整时期，中苏关系恶化，CD错误。所以答案选B。</span><p style=''>考点：中国特色社会主义建设的道路·20世纪50年代至70年代探索社会主义建设道路的实践·一五计划</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >以下是四幅新中国不同时期的宣传画。按画中主题体现的时间先后顺序，排列正确的是</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027086186815488/2030176852803584/STEM/13d7a041738047ae90ee5a61c91d032c.png\" width=\"529\" height=\"197\" /></p>",
            "options": {
              "A": "<span style=\"\" >①②③④</span>",
              "B": "<span style=\"\" >②③①④</span>",
              "C": "<span style=\"\" >③①②④</span>",
              "D": "<span style=\"\" >④②③①</span>"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查学生解读史料获取信息能力，旨在考查建国依赖政治制度演变，①是大跃进时期，发生在1958年;②发生在文革期间，即1966-1976年;③第一部宪法颁布是在1954年;④香港回归是在1997年，故选C。</span><p style=''>现代中国的政治建设与祖国统一•民主政治制度的发展与曲折•第一部宪法颁布与“文革”;现代中国的政治建设与祖国统一•“一国两制”的理论与实践?香港回归;中国特色社会主义建设的道路•20世纪50年代至70年代探索社会主义建设道路的实践•1958年大跃进</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" > 1982年颁布的《中华人民共和国宪法》规定，在县以下设立乡、民族乡、镇一级人民政府，作为一级行政机关，以此取代人民公社行使行政权力。下列属于这一规定出台背景的是</span></p>",
            "options": {
              "A": "家庭联产承包责任制的广泛推行",
              "B": "社会主义市场经济体制已初步建立",
              "C": "政企分开的管理体制已普遍实行",
              "D": "经济体制改革全面从农村转向城市"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：据材料提到，1982年……在县以下设立乡、民族乡、镇一级人民政府，作为一级行政机关，以此取代人民公社行使行政权力。结合所学知识可知，1978年家庭联产承包责任制推行，人民公社体制逐渐废除，故A正确。社会主义市场经济体制初步建立，在1992年后，故B排除。政企分开的管理体制已普遍实行，在城市，与人民公社无关，故C排除。经济体制改革全面从农村转向城市，在1984年后，故D排除。</span><p style=''>考点：中国特色社会主义建设的道路·从计划经济到市场经济·农村改革</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1953年10月，中共中央决定在全国范围内实行粮食的统购统销，在农村向全部农户实行粮食计划收购的政策，由国家严格控制粮食市场。粮食的统购统销</span></p>",
            "options": {
              "A": "<span style=\"\" >加快了我国农村经济的恢复和发展</span>",
              "B": "<span style=\"\" >有力地促进了各地农村的政权建设</span>",
              "C": "<span style=\"\" >将农民经济生活纳入国家计划体制</span>",
              "D": "<span style=\"\" >为国家工业化建设提供劳动力资源</span>"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >根据所学，A出现于1949年—1952年，此时国民经济的恢复工作已经完成，故A错误。题干中的“统购统销”是经济方面的政策，不涉及政权建设，故B项错误。1953年至1956年是中国三大改造时期，材料中内容符合农业改造时期的内容，通过改造，计划经济体制开始建立，故选C项。对粮食实行统购统销，有助于国家集中粮食资源支援工业生产，但并未涉及劳动力资源，故D项错误。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：从材料中的时间“1953年10月”可知这时我国开始了三大改造和第一个五年计划，中国的计划经济体制正在形成，而“粮食的统购统销”是这一体制的重要内容。</span></p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >邓小平说：“证券、股市，这些东西究竟好不好，有没有危险，是不是资本主义独有的东西，社会主义能不能用？允许看，但要坚决地试。看对了，搞一两年对了，放开；错了，纠正，关了就是了。”这段话主要反映的是</span></p>",
            "options": {
              "A": "<span style=\"\" >经济建设既要防“左”又要反“右”</span>",
              "B": "<span style=\"\" >经济体制改革重心从农村转向城市</span>",
              "C": "<span style=\"\" >设立沿海经济特区有必要进行试验</span>",
              "D": "<span style=\"\" >市场经济并不是资本主义所独有的</span>"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >题干材料中的“证券、股市”都属于市场经济，在我国改革开放前，我国的计划经济实行粮票、布票、油票，但是改革开放后，邓小平强调“证券、股市”这种市场经济并不是资本主义所独有的。故</span><span style=\"font-family: Times New Romance;\" >D</span><span style=\"font-family: 宋体;\" >符合题意；</span><span style=\"font-family: Times New Romance;\" >ABC</span><span style=\"font-family: 宋体;\" >三项在材料中没有体现。由此分析</span><span style=\"font-family: Times New Romance;\" >ABC</span><span style=\"font-family: 宋体;\" >不合题意，故此题选</span><span style=\"font-family: Times New Romance;\" >D。</span></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1979年7月，中国通过了《中外合资经营企业法》，80年代相继颁布《涉外经济合同法》《外资企业法》和《中外合作经营企业法》等。这些文件的发布</span></p>",
            "options": {
              "A": "表明中国已经融入世界经济体系",
              "B": "主要是为了发展市场经济",
              "C": "增强了政府对外开放政策的可信度",
              "D": "巩固了社会主义公有制经济"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查我国的对外开放。</span><p style=''>题干列举的各项法律为我国在对外开放过程中与外商合资、经营等活动提供了规范，使之制度化、法律化，表明政府推进对外开放的决心。当时的中国刚刚实行改革开放，外界对此态度不明，制定这些法律可以减少外界疑虑，增强政府的可信度，能够有效吸引外资。颁布这些法律正是为了更好地融入世界经济体系，并非表明我国已经融入。发展市场经济是最终目的，但题干只是强调完善对外开放的相关法律。故本题正确答案为C。</p><p style=''>考点：中国特色社会主义建设的道路·对外开放格局的初步形成·对外开放</p><p style=''>【名师点睛】本题可以参照政治学科知识，我国的外商企业分为中外合资经营企业、中外合作经营企业和外资企业三种类型。我国的外资企业立法是伴随着我国的改革和对外开放政策而逐步建立并不断完善的，至今已形成较为完备的外资企业立法体系。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1979年7月，中共中央做出决定，要求广东和福建两省“发挥优越条件，抓紧当前有利的国际形势，先走一步”。其直接结果是</span></p>",
            "options": {
              "A": "<span style=\"\" >推行家庭联产承包责任制</span>",
              "B": "<span style=\"\" >设立经济特区</span>",
              "C": "<span style=\"\" >建立社会主义市场经济体制</span>",
              "D": "<span style=\"\" >开展国企改革</span>"
            },
            "children": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：家庭联产承包责任制的开创是在安徽和四川，故A项错误；提出建立社会主义市场经济体制的目标是在1992年，故C项错误；国企改革是在1984年开始，故D项错误；1980年全国人大批准在广东、福建两省建立经济特区，所以本题答案为B项。</span><p style=''>考点：中国特色社会主义建设道路•新时期社会主义建设•对外开放</p><p style=''>【名师点睛】本题以1979年中共中央的决定为切入点，考查考生对改革开放过程的理解和认识，意在考查考生阅读和获取信息、调动和运用知识以及因果逻辑推理的能力。本题的解答比较容易，试题的命制契合了当今全球化的时代热点，解题的关键是把握材料给出的时空信息。这说明高考试题对时空意识的考查从来没有淡化，这是考生必须掌握的基本素养。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >“单干邀伴变互助，小组联起变大组，大组变做合作社，领导要靠党支部。”这首歌谣反映了</span></p>",
            "options": {
              "A": "<span style=\"\" >人民公社化运动</span>",
              "B": "<span style=\"\" >家庭联产承包责任制</span>",
              "C": "<span style=\"\" >农业社会主义改造</span>",
              "D": "<span style=\"\" >中共八大经济方针</span>"
            },
            "children": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：根据所学知识，1953-1956年新中国开展社会主义改造，其中农业采取合作化的道路，从临时的互助组发展到初级社，再发展到高级农业生产合作社的过渡形式，这与材料所述相符，因此选C。人民公社化运动开始于1958年，各地农村大办人民公社；家庭（联产）承包责任制开始于1979年，以家庭为单位，实行包产到户，自负盈亏；中共八大经济方针是指在综合平衡中稳步前进，都与材料所述情景不符，排除ABD。</span><p style=''>考点：中国特色社会主义建设的道路·20世纪50年代至70年代探索社会主义建设道路的实践·三大改造。</p><p style=''>【名师点睛】国家对农业的改造即农业合作化的过程。从临时的互助组发展到初级社，再发展到高级农业生产合作社的过渡形式。互助组是具有社会主义萌芽性质的组织，初级社是半社会主义性质的，高级社是完全社会主义性质的。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图是我国“一五”计划期间为配合大规模建设而绘制的宣传海报．对其解读正确的是</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272264705/STEM/ccead0835641487ca16b86d271561187.png\" width=\"169\" height=\"209\" /></p>",
            "options": {
              "A": "远处的工厂寓意工业化基本实现",
              "B": "图下的文字宣传了绿色环保观念",
              "C": "往来的船只说明交通运输业基础良好",
              "D": "工作的场景展现工人投身建设的热情"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查新中国的“一五计划”。</span><p style=''>A项，结合所学知识可知，“一五计划”期间，我国工业建设取得了巨大的成就，初步奠定了国家工业化的基础，但是谈不上基本实现工业化。故A项错误。</p><p style=''>B项，图下的文字为“把祖国建设得更美丽”，体现的是人们对改变祖国落后面貌的迫切愿望，与绿色环保观念无关。故B项错误。</p><p style=''>C项，结合所学知识，建国初期，新中国面对的是一个千疮百孔的烂摊子，农业、工业、交通运输业等各项关系国计民生的经济领域的基础都被破坏殆尽，往来的船只都是“一五计划”建设所取得的成就。故C项错误。</p><p style=''>D项，依据图片，图片描绘的是两位工人正在合力搭建工业生产设施，并且精神饱满，展现了工人投身祖国建设的热情。故D项正确。综上所述，本题正确答案为D。</p><p style=''>考点：中国特色社会主义建设•20世纪50年代探索•“一五”计划</p><p style=''>【名师点睛】本题属于热点考查试题，今年是社会主义制度确立：三大改造完成60周年（1956年）；三大改造的完成，标志着社会主义制度在中国的确立。这一知识点在现代中国经济历史中占有重要的地位，每年高考都会从中命题。今年是社会主义制度在中国确立60周年，更应该引起重视，复习要联系政治史、思想文化史以及经济历史综合梳理。</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >有学者指出：事实上农民远非如许多人想象的那样是一个制度的被动接受者，他们有着自己的期望、思想和要求。他们一直有着“反道而行”的“对应”行为，从而以不易察觉的方式改变、修正，或是消解着上级的政策与制度。下列史实中，最能佐证材料观点的是</span></p>",
            "options": {
              "A": "发动农业合作化运动",
              "B": "“大跃进”运动的掀起",
              "C": "确立了人民公社体制",
              "D": "农业生产责任制萌发"
            },
            "children": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题考查学生解读史料获取信息的能力。材料中“农民并非是一个制度的被动接受者”说明农民主动实施某种制度,改革开放前安徽凤阳小岗村村民正是自己闯出了一条农业承包责任的形式新路，符合题干意思，故本题选择D项；A、B和C均是“制度的被动接受条件下产物”不符合题意。</span><p style=''>考点：中国特色社会主义建设的道路、家庭联产承包责任制和国有企业改革</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >“一五”计划期间，我国住宅建设占基本建设投资额的比重不断减少，其他非生产性建设投资也开始受到抑制。这表明我国</span></p>",
            "options": {
              "A": "<span style=\"\" >致力于奠定工业化基础</span>",
              "B": "<span style=\"\" >国民经济结构臻于平衡</span>",
              "C": "<span style=\"\" >大力压缩基本建设投资规模</span>",
              "D": "<span style=\"\" >城市化的进程趋于缓慢</span>"
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：材料中缩减的是住宅建设和非生产性建设投资，但没有标明基本建设投资总额减少，故C项说错误；由此可以推断出生产性建设投资大幅提升，故A项说法正确；B项说法在材料中得不出；D项说法错误。</span><p style=''>考点：中国特色社会主义建设的道路·20世纪50年代至70年代探索社会主义建设道路的实践·一五计划</p></span>"
          },
          {
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1980年与1975年相比，我国粮食播种面积减少6884万亩，总产量却增加674亿斤；棉花播种面积减少53万亩，总产量却增加652万担；油料作物和甜菜播种面积共扩大3626万亩，其总产量分别增加70%和150%．出现这一现象的主要原因是</span></p>",
            "options": {
              "A": "<span style=\"\" >农民生产自主权的扩大</span>",
              "B": "<span style=\"\" >农业生产技术有了革命性的改变</span>",
              "C": "<span style=\"\" >农村经济体制改革完成</span>",
              "D": "<span style=\"\" >国家取消对农副产品的统销政策</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "children": [

            ],
            "answer": "A",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：据材料提到，1980年与1975年相比，我国粮食播种面积减少6．884万亩，总产量却增加674亿斤；……油料作物和甜菜播种面积共扩大3626万亩，其总产量分别增加70%和150%。结合所学知识可知，出现这一现象的主要原因是家庭联产承包责任制实行，农民生产自主权扩大，故A正确。当时农业生产技术没有革命性的改变，故B排除。当时农村经济体制改革开始不久，故C排除。国家取消对农副产品的统销政策，不是主要原因，故D排除。</span><p style=''>考点：中国特色社会主义建设的道路·从计划经济到市场经济·家庭联产承包责任制</p></span>"
          },
          {
            "id": 12062944,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >2016年4月，习近平在安徽考察时指出：“当年贴着身家性命干的事，变成中国改革的一声惊雷，成为中国改革的标志。”其中“贴着身家性命干的事”指</span></p>",
            "options": {
              "A": "<span style=\"\" >经济特区的建立</span>",
              "B": "<span style=\"\" >家庭联产承包责任制</span>",
              "C": "<span style=\"\" >人民公社化运动</span>",
              "D": "<span style=\"\" >土地改革运动</span>"
            },
            "difficult": {
              "id": 5,
              "name": "困难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T10:43:21",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" ></span><span style=\"font-size: 15px;font-family: 宋体;\" >依据题干所给信息：“安徽”、“当年贴着身家性命干的事，变成中国改革的一声惊雷，成为中国改革的标志”，结合所学可知，1978年12月18日晚，安徽阜阳县的小岗村在队长严俊昌的带领下，召开了秘密会议，小岗生产队在全国农村率先搞“包产到户”，打破了大锅饭，极大调动八亿农民的社会主义积极性；解放农村生产力，促进农村经济发展，B项符合题意；A项是在我国东南沿海建立的经济特区，不符合题意；C项是探索社会主义建设道路过程中的严重失误；D项农民分到土地，但生活没有很大改变，不符合题意。故选B。</span></span>"
          },
          {
            "id": 12064253,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图为中国1952-1960年工农业总产值变化图。对此分析符合史实的是</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272035328/STEM/20645e2f76f243d8ab29bde28048a668.png\" width=\"447\" height=\"237\" /></p>",
            "options": {
              "A": "“过渡时期”农业总产值始终超过工业总产值",
              "B": "“三大改造期间”工业总产值均高于农业总产值",
              "C": "“一五”计划完成时工农业总产值都大幅度的提高",
              "D": "大跃进使工农业总产值增长呈现背离状态"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:32:16",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >根据图表数据，并结合所学知识，“过渡时期”是指1949-1956年期间，而图中显示1956年以后工业总产值高于农业总产值，故排除A项；“三大改造期间”是指1953-1956年期间，而图中显示1953年-1955年期间工业总产值低于农业总产值，故排除B项；“一五”计划完成时是在1957年，而1956年以后农业总产值呈现下降趋势，故排除C项；1958年大跃进开展，由于片面发展重工业，影响了农业的生产，使工农业总产值增长呈现背离状态，故D项正确。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：本题考查新中国工业化的相关知识，结合过渡时期总路线、三大改造、“一五”计划、“大跃进”等知识点，分析图片信息。</span></p></span>"
          },
          {
            "id": 12073532,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >“走向世界丛书”于20世纪80年代开始出版，所收著作记录了近代国人亲历西方的见闻感言，如容闳的《西学东渐记》、康有为的《欧洲十一国游记》等，反响极大。该丛书的出版</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >①展现了近代国人走出国门、了解世界的历程</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >②改变了近代中国闭关锁国、盲目自大的局面</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >③为中国改革开放、融入世界提供了历史借鉴</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >④开创了中国独立自主的和平外交新局面。</span></p>",
            "options": {
              "A": "①②",
              "B": "②③",
              "C": "①③",
              "D": "②④"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:27:19",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25796,
                "name": "第四单元 20世纪以来中国的重大思想理论成果",
                "pathIds": "25796",
                "textbookId": 1188
              },
              {
                "id": 26292,
                "name": "第六单元 20世纪以来中国重大思想理论成果",
                "pathIds": "26292",
                "textbookId": 1161
              },
              {
                "id": 26586,
                "name": "专题四 20世纪以来中国重大思想理论成果",
                "pathIds": "26586",
                "textbookId": 1179
              }
            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"\" >试题分析：本题主要考查走向世界。根据材料信息，结合所学知识可知“走向世界丛书”反映的是中国人积极主动地向西方学习，展现了近代国人走出国门、了解世界的历程，也为今天的中国改革开放、融入世界提供了历史借鉴，而改变了近代中国闭关锁国、盲目自大的局面是鸦片战争，凡是含②均是错误的，“走向世界丛书”和建国之后开创中国独立自主的和平外交新局面无关，凡是含④均是错误的，选C是符合题意的，正确；选项A含②，不符合题意，排除；选项B含②，不符合题意，排除；选项D含②，不符合题意，排除；故本题选C。</span><p style=''>考点：中国的近代化•近代化的主题•走向世界</p></span>"
          },
          {
            "id": 16669005,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >1985年1月江苏省人民政府作出决定：将一批省属企业下放给所在地（市）领导管理，下放的企业中有南京机床厂、江南水泥厂、江苏玻璃厂等34个省属企业。该决定主要是为了</span></p>",
            "options": {
              "A": "<span style=\"\" >调整工业布局</span>",
              "B": "<span style=\"\" >实行政企分开</span>",
              "C": "<span style=\"\" >增强企业活力</span>",
              "D": "<span style=\"\" >鼓励租赁经营</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:05:57",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >根据“将一批省属企业下放给所在地（市）领导管理”反映了权利的下放，目的是为了增强企业活力，故C正确。题干与调整工业布局无关，排除A项；B项不是主要目的；D项不符合题意。</span></span>"
          },
          {
            "id": 17640403,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1981年底，经过调查研究，国家相关部门认为，扩大出口创汇存在三大问题：一是外贸垄断体制，二是产品质量低，三是出口亏损。为解决这些问题，他们提出了若干建议，其中包括</span></p>",
            "options": {
              "A": "<span style=\"\" >对国营企业进行股份制改革</span>",
              "B": "<span style=\"\" >扩大外贸企业的经营自主权</span>",
              "C": "<span style=\"\" >争取早日加入世界贸易组织</span>",
              "D": "<span style=\"\" >在广东等省市设立经济特区</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T10:58:39",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >材料中反映的外贸垄断体制，产品质量低，出口亏损等现象的出现，主要与当时中国实行的计划经济体制有关，在计划经济体制下，企业没有自主权，导致难以扩大出口创汇。因此，对应的建议应是扩大企业的经营自主权，故B项正确。股份制改革是在1992年之后才实行的，排除A项；中国1986年才提出“复关”，排除C项；我国第一批经济特区此时已经设立，排除D项。</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >【考点定位】中国特色社会主义建设的道路·从计划经济到市场经济</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >点睛：改革开放以来，中国现代化建设道路的探索主要包括以下四个方面：</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（1）党的十一届三中全会后，开始了农村经济体制改革。</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（2）20世纪80年代后，城市经济体制改革也全面展开。</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（3）对外开放经历了创办经济特区、开辟沿海开放城市、开辟沿海经济开放区、开放内地等步骤。</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >（4）20世纪90年代，社会主义市场经济体制逐渐建立起来。</span></p></span>"
          },
          {
            "id": 17743850,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >如图是创作于1950年的宣传画《拖拉机》，该作品反映出</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272051712/STEM/fe9f1795a8b84cf8ac7a148eb80cae46.png\" width=\"305\" height=\"207\" /></p>",
            "options": {
              "A": "<span style=\"\" >农村开始走上人民公社化道路</span>",
              "B": "<span style=\"\" >农业机械化已在农村得到普及</span>",
              "C": "<span style=\"\" >农业生产方式将发生巨大变化</span>",
              "D": "<span style=\"\" >农村掀起社会主义改造的高潮</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T10:58:08",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [

            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >由图中信息可知，1950年拖拉机成为农村的农业生产工具。人民公社化开始于1958年，故A错误；农业机械化在农村普及是改革开放后的成就，故B错误；社会主义改造的高潮是在1953年以后，故D错误；拖拉机成为农业生产工具，这预示着机器将取代人力成为农业的生产方式，故C正确。</span><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >【考点定位】新中国经济建设••过渡时期的经济建设••对农业的社会主义改造</span></p><p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >点睛：本题通过1950年的宣传画来考查考生对建国后农业改革的认识，考查考生提取和解读信息、调动和运用知识的能力，考查唯物主义、时空意识、历史解释和史料实证等核心素养。时空意识是新课标高考命题的核心素养之一，准确的时空意识是考生的基本历史素养。本题是时间信息是“1950年”，由此时间可排除ABD三项，准确定位答案为C项。</span></p></span>"
          },
          {
            "id": 17927057,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >据图判断，下列选项正确的是</span></p><p style='line-height: 24px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272158208/STEM/f58d1a2be1ba44f7a4bab6ca2942f18e.png\" width=\"490\" height=\"265\" /></p>",
            "options": {
              "A": "<span style=\"\" >工商业社会主义改造导致服务网点锐减</span>",
              "B": "<span style=\"\" >第一个五年计划推动了北京服务业发展</span>",
              "C": "<span style=\"\" >经济体制改革极大激发了北京市场活力</span>",
              "D": "<span style=\"\" >加入世贸组织使北京商品供应更加多样</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:07:41",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 9991,
                "name": "经济特区和经济开发区",
                "pathIds": "9865,9967,9990,9991",
                "subjectId": 33
              },
              {
                "id": 9995,
                "name": "外开放的基本格局",
                "pathIds": "9865,9967,9990,9995",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >“三大改造”进行于1953年至1956年，A错误。第一个五年计划进行于1953—1957年，B错误。十一届三中全会后单一的经济体制转变为以公有制为主体，多种经济成分并存的经济体制，这大大促进了市场的活力，C正确。2001年加入世贸组织，D错误。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >【要点解密】</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >本题主要考查学生对我国改革开放的准确识记。依据已学知识可知，1985年开始，城市改革全面展开，重点是国有企业的改革。基本建立了现代企业制度国企改革始终是我国经济体制改革的核心，其过程大致经历了三个阶段:1978-1986年为计划经济体制占主导地位前提下的放权让利改革阶段，主要目的是通过扩大企业自主权和物质刺激，调动企业的生产经营积极性1992年至今，主要是在市场经济运行机制逐渐占据主导地位条件下，建立现代企业制度。党的十四大以后，党中央国务院明确提出我国经济体制改革的目标是建立社会主义市场经济体制。1993年中共十四届三中全会正式确定，把建立现代企业制度作为国有企业改革的方向和目标。</span></p></span>"
          },
          {
            "id": 19639078,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >下图是1953年的一幅漫画，描绘了资源勘探队员来到深山，手持“邀请函”叩响山洞大门的情景。这反映了当时我国</span></p><p style='line-height: 24px;text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/7/17/1990517674082304/1993123189473280/STEM/43662ba2987c42e38cf8d94061e73bab.png\" width=\"250\" height=\"152\" /></p>",
            "options": {
              "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >已经初步改变工业落后局面</span>",
              "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >开始进行对矿产资源的开采</span>",
              "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >国民经济调整任务基本完成</span>",
              "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >大规模的经济建设正在展开</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:40:10",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 1,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [

            ],
            "knowledgePoints": [
              {
                "id": 9971,
                "name": "过渡时期总路线与“一五计划”",
                "pathIds": "9865,9967,9968,9969,9971",
                "subjectId": 33
              },
              {
                "id": 9976,
                "name": "国民经济的调整",
                "pathIds": "9865,9967,9968,9973,9976",
                "subjectId": 33
              },
              {
                "id": 9969,
                "name": "社会主义建设的起步",
                "pathIds": "9865,9967,9968,9969",
                "subjectId": 33
              },
              {
                "id": 9973,
                "name": "探索与失误",
                "pathIds": "9865,9967,9968,9973",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "D",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" >由材料信息“</span><span style=\"font-family: Times New Romance;\" >1953</span><span style=\"font-family: 宋体;\" >年”“资源勘探”等信息并结合所学知识得出，此时正是“一五计划”轰轰烈烈进行之时，故</span><span style=\"font-family: Times New Romance;\" >D</span><span style=\"font-family: 宋体;\" >项正确；</span><span style=\"font-family: Times New Romance;\" >1957</span><span style=\"font-family: 宋体;\" >年“一五计划”超额完成表明中国已经初步改变了工业落后的面貌，故</span><span style=\"font-family: Times New Romance;\" >A</span><span style=\"font-family: 宋体;\" >项错误；新中国成立前，中国已经开始对矿产资源进行开采，故</span><span style=\"font-family: Times New Romance;\" >B</span><span style=\"font-family: 宋体;\" >项错误；国民经济调整任务基本完成是在</span><span style=\"font-family: Times New Romance;\" >1965</span><span style=\"font-family: 宋体;\" >年，故</span><span style=\"font-family: Times New Romance;\" >C</span><span style=\"font-family: 宋体;\" >项错误。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：本题落实时空观念的考查，考查基本知识和基本能力，试题比较简单，运用所学知识即可排除。全国卷高考近几年趋于平和，这就启示我们平时备考不能忽略主干知识和基本能力。</span></p></span>"
          },
          {
            "id": 19643125,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >京津塘高速公路是第一条经国务院批准并部分利用世界银行贷款建设的跨省、市高速公路，1987年12月动工。这条高速公路的修建能够得到世界银行贷款，主要是因为改革开放后我国</span></p>",
            "options": {
              "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >加入亚太经合组织</span>",
              "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >将天津设为沿海开放城市</span>",
              "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >恢复世界银行席位</span>",
              "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >成功加入世界贸易组织</span>"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:35:30",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25761,
                "name": "第三单元 中国特色社会主义建设的道路",
                "pathIds": "25761",
                "textbookId": 1187
              },
              {
                "id": 26253,
                "name": "第四单元 中国特色社会主义建设的道路",
                "pathIds": "26253",
                "textbookId": 1160
              },
              {
                "id": 26548,
                "name": "专题三 中国社会主义建设道路的探索",
                "pathIds": "26548",
                "textbookId": 1178
              },
              {
                "id": 26978,
                "name": "第四单元 中国社会主义建设发展道路的探索",
                "pathIds": "26978",
                "textbookId": 1169
              },
              {
                "id": 40259,
                "name": "第四单元 中国社会主义建设发展道路的探索",
                "pathIds": "40259",
                "textbookId": 2221
              },
              {
                "id": 25781,
                "name": "第22课 战后资本主义世界经济体系的形成",
                "pathIds": "25780,25781",
                "textbookId": 1187
              },
              {
                "id": 26269,
                "name": "第22课 战后资本主义世界经济体系的形成",
                "pathIds": "26268,26269",
                "textbookId": 1160
              },
              {
                "id": 26570,
                "name": "一 二战后资本主义世界经济体系的形成",
                "pathIds": "26569,26570",
                "textbookId": 1178
              },
              {
                "id": 26985,
                "name": "第23课 战后资本主义世界经济体系的形成",
                "pathIds": "26984,26985",
                "textbookId": 1169
              },
              {
                "id": 40266,
                "name": "第24课 战后资本主义世界经济体系的形成",
                "pathIds": "40265,40266",
                "textbookId": 2221
              }
            ],
            "knowledgePoints": [
              {
                "id": 9984,
                "name": "经济体制改革",
                "pathIds": "9865,9967,9981,9984",
                "subjectId": 33
              },
              {
                "id": 10057,
                "name": "世界货币体系的建立",
                "pathIds": "9865,10055,10056,10057",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" ></span><span style=\"font-size: 16px;font-family: 宋体;\" >依据已学知识可知，</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >1991</span><span style=\"font-size: 16px;font-family: 宋体;\" >年中国加入亚太经合组织，与题中时间信息不符合，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >A</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除；依据已学知识可知，</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >1984</span><span style=\"font-size: 16px;font-family: 宋体;\" >年国家决定开放天津、上海、福州、广州等</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >14</span><span style=\"font-size: 16px;font-family: 宋体;\" >个沿海开放港口城市，但是这与中国得到世界银行的贷款没有必然联系，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >B</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除；世界银行的宗旨是提供全球性的发展援助，为成员国提供长期贷款和技术援助，中国</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >得到世界银行贷款</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”</span><span style=\"font-size: 16px;font-family: 宋体;\" >的前提是中国必须是世界银行的成员国，结合所学知识可知，</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >1980</span><span style=\"font-size: 16px;font-family: 宋体;\" >年，我国正式恢复了在世界银行中的成员国席位，为利用外资搞建设开辟了新途，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >C</span><span style=\"font-size: 16px;font-family: 宋体;\" >项正确；</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >2001</span><span style=\"font-size: 16px;font-family: 宋体;\" >年中国成功加入世界贸易组织，与题中时间信息不符合，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >D</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >【名师点晴】世界银行成立于</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >1945</span><span style=\"font-size: 16px;font-family: 宋体;\" >年，是根据《布雷顿森林协定》成立的两大金融机构之一，主要向发展中国家提供中长期贷款与投资，促进发展中国家经济和社会发展，中国是世界银行的创始国之一，新中国成立后，中国在世界银行的席位长期为台湾当局所占据，</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >1980</span><span style=\"font-size: 16px;font-family: 宋体;\" >年</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >5</span><span style=\"font-size: 16px;font-family: 宋体;\" >月，中国在世界银行合法席位得到恢复。</span></p></span>"
          },
          {
            "id": 19643126,
            "stem": "<p style='line-height: 24px;'><span style=\"font-size: 14px;font-family: 宋体;\" >中国共产党分别于1956、1969、1982、1992年召开第八、九、十二、十四次全国代表大会。下表是对这四次大会政治报告中出现的前10个高频词的次数统计。其中与党的十二大相对应的一组是</span></p><p style='line-height: 24px;'></p><p style='line-height: 24px;margin-left: 30px;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/2029493272150017/STEM/5cd31ab0e8d1410a9e02e4f19b96dbb3.png\" width=\"413\" height=\"157\" /></p><p style='line-height: 24px;margin-left: 30px;'></p><p style='line-height: 24px;margin-left: 30px;'></p><p style='line-height: 24px;margin-left: 30px;'></p><p style='line-height: 24px;margin-left: 30px;'></p><p style='line-height: 24px;'></p>",
            "options": {
              "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >①</span>",
              "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >②</span>",
              "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >③</span>",
              "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >④</span>"
            },
            "difficult": {
              "id": 2,
              "name": "较易"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:35:30",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 26551,
                "name": "三 走向社会主义现代化建设新阶段",
                "pathIds": "26548,26551",
                "textbookId": 1178
              }
            ],
            "knowledgePoints": [
              {
                "id": 9984,
                "name": "经济体制改革",
                "pathIds": "9865,9967,9981,9984",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" ></span><span style=\"font-size: 16px;font-family: 宋体;\" >解题时紧扣</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >十二大</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”</span><span style=\"font-size: 16px;font-family: 宋体;\" >等关键信息，然后联系已学知识可知，对四次会议的特征进行逐项对比分析。首先，可从特征比较明显的会议开始进行分析。中共九大是在</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >文革</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”</span><span style=\"font-size: 16px;font-family: 宋体;\" >期间召开的，主要特征是以阶级斗争为纲，故出现频率高的词汇应为</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >阶级</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”、“</span><span style=\"font-size: 16px;font-family: 宋体;\" >革命</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”，</span><span style=\"font-size: 16px;font-family: 宋体;\" >④与之相符，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >D</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除；中共十四大提出了建设社会主义市场经济体制的目标，动员全党同志和全国各族人民，进一步解放思想，把握有利时机，加快改革开放和现代化建设步伐，夺取有中国特色社会主义事业的更大胜利，因此此时出现频率最高的词汇应为</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >经济</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”“</span><span style=\"font-size: 16px;font-family: 宋体;\" >建设</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”，</span><span style=\"font-size: 16px;font-family: 宋体;\" >③与之相符，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >C</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除。然后，再结合所学知识对中共八大和十二大的主要特征进行分析。中共八大正确地分析了社会主义改造基本完成以后，中国阶级关系和国内主要矛盾的变化，确定把党的工作重点转向社会主义建设，着重提出了执政党的建设问题，故其</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >阶级</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”</span><span style=\"font-size: 16px;font-family: 宋体;\" >一词出现的频率比中共十二大高，与</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >①</span><span style=\"font-size: 16px;font-family: 宋体;\" >的高频词相一致，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >A</span><span style=\"font-size: 16px;font-family: 宋体;\" >项排除；中共十二大提出建设有中国特色的社会主义，提出了党在新的历史时期的总任务，即团结全国各族人民，自力更生，艰苦奋斗，逐步实现工业、农业、国防和科学技术的现代化，把我国建设成为高度文明、高度民主的社会主义国家，②与之符合，故</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >B</span><span style=\"font-size: 16px;font-family: 宋体;\" >项正确。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >【名师点晴】党的历史上有很多重要的会议，试题主要考查对历次会议核心内容的准确认识。</span></p><table style=\"border-width:0px 0px 0px 0px;border-style:solid;border-color:black;border-collapse: collapse;\"><tr  height=\"21px\"><td style=\"width:64px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中共</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >八大</span></p></td><td style=\"width:340px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >正确地分析了社会主义改造基本完成以后，中国阶级关系和国内主要矛盾的变化，指出当时党和人民的主要任务是集中力量发展社会生产力，实现国家工业化，逐步满足人民群众日益增长的物质和文化需要</span></p></td><td style=\"width:253px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >对指导社会主义建设具有重要意义，是探索建设社会主义道路的良好开端</span></p></td></tr><tr  height=\"21px\"><td style=\"width:64px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中共</span></p><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >九大</span></p></td><td style=\"width:340px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >核心内容：无产阶级专政下继续革命的理论。大会通过的《中国共产党章程》对八大党章作了错误修改</span></p></td><td style=\"width:253px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >使</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >“</span><span style=\"font-size: 16px;font-family: 宋体;\" >文化大革命</span><span style=\"font-size: 16px;font-family: Times New Roman;\" >”</span><span style=\"font-size: 16px;font-family: 宋体;\" >的错误理论和实践合法化，在思想上、政治上、组织上的指导方针都是错误的</span></p></td></tr><tr  height=\"21px\"><td style=\"width:64px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中共十二大</span></p></td><td style=\"width:340px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >确定党为全面开创社会主义现代化建设新局面而奋斗的纲领，审议通过新的《中国共产党章程》；提出建设有中国特色的社会主义</span></p></td><td style=\"width:253px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中国进入全面开创社会主义现代化建设时期</span></p></td></tr><tr  height=\"21px\"><td style=\"width:64px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中共十四大</span></p></td><td style=\"width:340px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >中国进入全面开创社会主义现代化建设在全党的指导地位，提出建立社会主义市场经济体制</span></p></td><td style=\"width:253px;border-width:1px 1px 1px 1px;border-style:solid solid solid solid;border-color:black;\"><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 16px;font-family: 宋体;\" >改革开放和社会主义现代化建设进入一个新的阶段</span></p></td></tr></table></span>"
          },
          {
            "id": 19644741,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >1956年，刘少奇在中共八大政治报告中指出：“我们目前在国家工作中的迫切任务之一，是着手系统地制定比较完备的法律，健全我们国家的法制。”这反映了当时</span></p>",
            "options": {
              "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >法制建设开始迈向制度化</span>",
              "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >法制工作围绕组建新政权展开</span>",
              "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >法制建设与国内主要矛盾的变化密切相关</span>",
              "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >政治体制改革推动了依法治国的全面实行</span>"
            },
            "difficult": {
              "id": 4,
              "name": "较难"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:35:32",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 0,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25732,
                "name": "第11课 新中国的民主政治制度",
                "pathIds": "25731,25732",
                "textbookId": 1186
              },
              {
                "id": 26230,
                "name": "第20课 新中国的民主政治建设",
                "pathIds": "26229,26230",
                "textbookId": 1159
              },
              {
                "id": 26516,
                "name": "一 新中国初期的政治建设",
                "pathIds": "26515,26516",
                "textbookId": 1177
              },
              {
                "id": 26950,
                "name": "第21课 新中国的政治建设",
                "pathIds": "26949,26950",
                "textbookId": 1168
              },
              {
                "id": 40227,
                "name": "第22课 新中国的政治建设",
                "pathIds": "40226,40227",
                "textbookId": 2220
              }
            ],
            "knowledgePoints": [
              {
                "id": 9805,
                "name": "《中华人民共和国宪法》的颁布",
                "pathIds": "9583,9795,9796,9805",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "C",
            "analysis": "<span class=\"qml-general\"><span style=\"font-family: 宋体;\" ></span><span style=\"font-family: Times New Romance;\" >A</span><span style=\"font-family: 宋体;\" >在材料中未体现。新政权建立是在</span><span style=\"font-family: Times New Romance;\" >1949</span><span style=\"font-family: 宋体;\" >年，与材料时间“</span><span style=\"font-family: Times New Romance;\" >1956</span><span style=\"font-family: 宋体;\" >年”不符，故</span><span style=\"font-family: Times New Romance;\" >B</span><span style=\"font-family: 宋体;\" >错误；依据材料时间“</span><span style=\"font-family: Times New Romance;\" >1956</span><span style=\"font-family: 宋体;\" >年”，并结合所学知识可知，</span><span style=\"font-family: Times New Romance;\" >1956</span><span style=\"font-family: 宋体;\" >年中共八大正确分析了国内形势和主要矛盾的变化，提出了加强社会主义民主政治建设，健全国家法制，故</span><span style=\"font-family: Times New Romance;\" >C</span><span style=\"font-family: 宋体;\" >符合题意；材料中未体现政治体制改革，排除</span><span style=\"font-family: Times New Romance;\" >D。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >点睛：本题以民主法制建设这一热点问题切入考查新中国法制建设的相关知识。解答本题的关键是紧扣材料时间“</span><span style=\"font-family: Times New Romance;\" >1956</span><span style=\"font-family: 宋体;\" >年”结合时代背景分析。</span></p></span>"
          },
          {
            "id": 19648567,
            "stem": "<p style='line-height: 24px;text-align: left;'><span style=\"font-family: 宋体;\" >图为1956年的一副漫画《两把尺》（画中字：“奶奶的尺--量布做新衣。阿姨的尺--测量祖国，建设杜会主义。”该漫画反映了</span></p><p style='text-align: left;'><img  src=\"http://qbm-images.oss-cn-hangzhou.aliyuncs.com/QBM/2018/9/7/2027278006910976/null/STEM/66afe87f02ed43e3a36bbcad5114b17e.png\" width=\"189\" height=\"202\" /></p>",
            "options": {
              "A": "<span style=\"font-size: 14px;font-family: 宋体;\" >社会主义建设以工业化为中心</span>",
              "B": "<span style=\"font-size: 14px;font-family: 宋体;\" >女性成为国家建设的重要力量</span>",
              "C": "<span style=\"font-size: 14px;font-family: 宋体;\" >人民公社化运动蓬勃发展</span>",
              "D": "<span style=\"font-size: 14px;font-family: 宋体;\" >城乡差别发生根本性改变</span>"
            },
            "difficult": {
              "id": 3,
              "name": "一般"
            },
            "type": {
              "id": 3301,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2018-08-26T11:35:36",
            "children": [

            ],
            "isCollection": false,
            "zuJuanCount": 1,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [
              {
                "id": 25761,
                "name": "第三单元 中国特色社会主义建设的道路",
                "pathIds": "25761",
                "textbookId": 1187
              },
              {
                "id": 26253,
                "name": "第四单元 中国特色社会主义建设的道路",
                "pathIds": "26253",
                "textbookId": 1160
              },
              {
                "id": 26548,
                "name": "专题三 中国社会主义建设道路的探索",
                "pathIds": "26548",
                "textbookId": 1178
              },
              {
                "id": 26978,
                "name": "第四单元 中国社会主义建设发展道路的探索",
                "pathIds": "26978",
                "textbookId": 1169
              },
              {
                "id": 40259,
                "name": "第四单元 中国社会主义建设发展道路的探索",
                "pathIds": "40259",
                "textbookId": 2221
              }
            ],
            "knowledgePoints": [
              {
                "id": 9969,
                "name": "社会主义建设的起步",
                "pathIds": "9865,9967,9968,9969",
                "subjectId": 33
              }
            ],
            "childrenList": [

            ],
            "answer": "B",
            "analysis": "<span class=\"qml-general\"><span style=\"font-size: 14px;font-family: 宋体;\" >漫画中一位老奶奶用尺量布做衣服，小孙女在一旁翻看书本陪着老奶奶；两位女勘探队员肩上扛着工作用的长尺和三脚架等工具向这边走来。此画以小孙女的口气，用了这样的副标题：“奶奶的尺——量布做新衣。阿姨的尺——测量祖国，建设社会主义。”“奶奶的尺”与“阿姨的尺”这两种不同性质和用途的“尺”，反映了新老两代妇女的不同社会地位和作用，讴歌了新中国女青年投身社会主义建设事业，故选</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >B</span><span style=\"font-size: 14px;font-family: 宋体;\" >；工业化是用机器生产的形式，而材料中奶奶的用尺子做新衣属于手工劳动，故</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >A</span><span style=\"font-size: 14px;font-family: 宋体;\" >排除；人民公社化运动发生在</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >1958</span><span style=\"font-size: 14px;font-family: 宋体;\" >年，与题干中的“</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >1956</span><span style=\"font-size: 14px;font-family: 宋体;\" >年”不符，故排除</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >C</span><span style=\"font-size: 14px;font-family: 宋体;\" >；题干信息没有体现城市还是乡村，更没有城乡之间的对比，故</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >D</span><span style=\"font-size: 14px;font-family: 宋体;\" >与题意不符，所以排除。</span><p style='line-height: 24px;text-align: left;'><span style=\"font-size: 14px;font-family: 宋体;\" >名师点睛：漫画入题是新课标全国卷</span><span style=\"font-size: 14px;font-family: Times New Romance;\" >2017</span><span style=\"font-size: 14px;font-family: 宋体;\" >年开始出现的，今年再次出现，体现了全国卷坚持的创新风格，而且漫画以其独特的表现形式使得试卷图文并茂，由于浓缩了文字信息所没有的风格，所以对考生解读不同类材料的能力提出了更高的要求，如何准确而快速的解读漫画信息，是值得高三师生备考时努力的地方。这一题也考查了时空观念、历史解释等历史核心素养。</span></p></span>"
          }
        ]
      };
    },
    name: 'introduce',
    mounted() {},
    methods: {}
  }
</script>
<style scoped>
</style>
<style>

  .paper-example{
    background-color: #ffffff;
    width: 1200px;
    margin: 60px auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
    padding: 20px;
  }

  .paper-example h1{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/introduce/history-paper/paper-example-1/index.vue